// src/hooks/useStore.ts
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  applyInflation as applyInflationAction,
  setStoreGateways as setStoreGatewaysAction,
  setGiftcardMenu as setGiftcardMenuAction,
  setStoreId as setStoreIdAction,
  setMenuId as setMenuIdAction,
  setUtm as setUtmAction,
  selectHasAdInflation,
  selectOrderTypes,
  selectDefaultOrderType,
} from "../store/storeSlice";
import { StoreGatewayModel, StoreMenuModel } from "../models";

export const useStore = () => {
  const dispatch = useAppDispatch();

  const {
    storeId,
    menuId,
    utm,
    isMenuLoading,
    isLocationLoading,
    giftcardMenu,
    storeMenu,
    storeCategories,
    storeProducts,
    storeCoupons,
    storeLocations,
    selectedStore,
    storeGateways,
    isLoyaltyActive,
    loyaltyLevels,
    isGiftcardActive,
  } = useAppSelector((state) => state.store);

  const hasAdInflation = useAppSelector(selectHasAdInflation);
  const orderTypes = useAppSelector(selectOrderTypes);
  const defaultOrderType = useAppSelector(selectDefaultOrderType);

  // mimic old behavior: fetch menu + locations whenever storeId changes
  // useEffect(() => {
  //   if (!storeId) return;
  //   dispatch(fetchStoreMenu(storeId));
  //   dispatch(fetchStoreLocations(storeId));
  // }, [storeId, dispatch]);

  const setStoreId = useCallback(
    (id: string) => {
      dispatch(setStoreIdAction(id));
    },
    [dispatch],
  );

  const setMenuId = useCallback(
    (id: string) => {
      dispatch(setMenuIdAction(id));
    },
    [dispatch],
  );

  const setUtm = useCallback(
    (val: string) => {
      dispatch(setUtmAction(val));
    },
    [dispatch],
  );

  const applyInflation = useCallback(
    (typeId: string | number) => {
      dispatch(applyInflationAction(typeId));
    },
    [dispatch],
  );

  const setStoreGateways = useCallback(
    (gateways: StoreGatewayModel[]) => {
      dispatch(setStoreGatewaysAction(gateways));
    },
    [dispatch],
  );

  const setGiftcardMenu = useCallback(
    (menu: StoreMenuModel) => {
      dispatch(setGiftcardMenuAction(menu));
    },
    [dispatch],
  );

  return {
    storeId,
    setStoreId,
    menuId,
    setMenuId,
    utm,
    setUtm,
    hasAdInflation,
    isMenuLoading,
    giftcardMenu,
    setGiftcardMenu,
    storeMenu,
    storeCategories,
    storeProducts,
    storeCoupons,
    applyInflation,
    isLocationLoading,
    storeLocations,
    selectedStore,
    storeGateways,
    setStoreGateways,
    isLoyaltyActive,
    loyaltyLevels,
    isGiftcardActive,
    orderTypes,
    defaultOrderType,
  };
};
